import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    listParentId: '',
  };

  search() {
    const searchValue = $(this.element).val().toLowerCase();
    const parentDiv = $(`#${this.listParentIdValue}`);
    const links = parentDiv.find('.searchable-list-item');
    links.each((_, link) => {
      const jQueryLink = $(link);
      const linkValue = jQueryLink.attr('data-value').toLowerCase();
      if (linkValue.includes(searchValue)) {
        jQueryLink.show();
      } else {
        jQueryLink.hide();
      }
    })
  }
}
